export const CLASSIC_NO_TAX_OUTCOME_TEXTS = Object.freeze({
  title: "לא חייב במס",
  explanation:
    "כל רכיבי העסקה פטורים ממס שבח, ולכן אין צורך להפיק קובצי מס או טופס 2990.",
  reportingNote:
    "גם כאשר העסקה פטורה ממס שבח, עדיין קיימת חובת דיווח על העסקה."
});
